import { axiosClient } from "../client";

/**
 * INSIGHT-HIST-12 onwards — the historical analytics API.
 *
 * Four read endpoints served from BigQuery. They take the same filters, so the
 * dashboards share one set of controls.
 */

const HISTORICAL_SUMMARY = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/historical/summary`;

const HISTORICAL_STATIONS = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/historical/stations`;

const HISTORICAL_DELAYS = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/historical/delays`;

const HISTORICAL_TIMELINE = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/historical/timeline`;

/**
 * Drops empty filters so the query string carries only what was chosen.
 */
const cleanParams = (params = {}) =>
  Object.entries(params).reduce((carry, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      carry[key] = value;
    }
    return carry;
  }, {});

const request = (url, locationId, params) =>
  axiosClient({
    method: "GET",
    url,
    params: cleanParams(params),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

/**
 * Average, median, longest and target performance for one metric type.
 * params: { metricType, preset } or { metricType, startDate, endDate }, plus
 * any of stationId, driverId, channel, platform, mode, fromTime, toTime.
 * fromTime/toTime are HH:mm in restaurant local time, as toQueryParams sends
 * them.
 */
export const fetchHistoricalSummary = (locationId, params) =>
  request(HISTORICAL_SUMMARY(locationId), locationId, params);

/** Average duration per station, slowest first. */
export const fetchHistoricalStations = (locationId, params) =>
  request(HISTORICAL_STATIONS(locationId), locationId, params);

/** Orders that missed their target, slowest first. */
export const fetchHistoricalDelays = (locationId, params) =>
  request(HISTORICAL_DELAYS(locationId), locationId, params);

/** One order's events, completed durations and final record. */
export const fetchHistoricalTimeline = (locationId, params) =>
  request(HISTORICAL_TIMELINE(locationId), locationId, params);
